import React, { useState } from 'react';
import { Radio, Space } from 'antd';
import I18n from 'i18n-js';
import TicketComments from 'components/ticket-comments';
import TicketHistory from 'components/ticket-history';
import { number, bool } from 'prop-types';
import { DETAILED_INFO_TYPES } from './lib/constants';
import { currentUserInfoPropTypes, currentUserInfoDefaultPropTypes } from './propTypes';

const DetailedInfo = ({
  ticketId = null,
  currentUserInfo = currentUserInfoDefaultPropTypes,
  canSetInternalComment = false,
}) => {
  const [selectedDetailedInfoType, setSelectedDetailedInfoType] = useState('comments');

  const handleChange = (e) => {
    setSelectedDetailedInfoType(e.target.value);
  };

  return (
    <>
      <div className="tickets-index-page__ticket-detailed-info">
        <Radio.Group
          value={selectedDetailedInfoType}
          onChange={handleChange}
          className="tickets-detailed-info__presets"
        >
          {DETAILED_INFO_TYPES.map(({ key, i18n }) => (
            <Radio.Button key={key} value={key}>
              <Space align="baseline">
                {I18n.t(i18n)}
              </Space>
            </Radio.Button>
          ))}
        </Radio.Group>
      </div>

      {selectedDetailedInfoType === 'comments' && (
        <TicketComments
          key={ticketId}
          ticketId={ticketId}
          currentUserInfo={currentUserInfo}
          canSetInternalComment={canSetInternalComment}
        />
      )}

      {selectedDetailedInfoType === 'history' && (
        <TicketHistory key={ticketId} ticketId={ticketId} />
      )}
    </>
  );
};

DetailedInfo.propTypes = {
  ticketId: number,
  currentUserInfo: currentUserInfoPropTypes,
  canSetInternalComment: bool,
};

export default DetailedInfo;
